import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  InputSignal,
  OutputEmitterRef,
  input,
  output,
} from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

import { FilterSelectionOption } from '../../models';
import { FilterOptionComponent, OptionLabelTemplateRef } from '../filter-option/filter-option.component';

@Component({
  selector: 'mp-single-selection-filter',
  templateUrl: './single-selection-filter.component.html',
  styleUrl: './single-selection-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRadioModule, FilterOptionComponent],
})
export class SingleSelectionFilterComponent<T> {
  @HostBinding() readonly class = 'mp-single-selection-filter';

  readonly options: InputSignal<FilterSelectionOption<T>[]> = input.required<FilterSelectionOption<T>[]>();

  readonly selectedValue: InputSignal<T | undefined> = input<T | undefined>(undefined);

  readonly optionLabelTemplate: InputSignal<OptionLabelTemplateRef<T> | undefined> = input<OptionLabelTemplateRef<T>>();

  readonly selectedValueChange: OutputEmitterRef<T> = output<T>();

  readonly optionSelect: OutputEmitterRef<FilterSelectionOption<T>> = output<FilterSelectionOption<T>>();

  onSelectedOptionChange(selectedOption: FilterSelectionOption<T>): void {
    this.selectedValueChange.emit(selectedOption.value);
    this.optionSelect.emit(selectedOption);
  }
}
